<template>
    <div>
        <div v-if="!componentToRender" class="flex min-h-screen items-center justify-center bg-base-100"
            aria-busy="true" aria-label="Loading organization">
            <span class="loading loading-spinner loading-lg text-primary" aria-hidden="true"></span>
        </div>
        <component v-else :is="componentToRender"></component>
    </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { useOrganizationStore } from '../stores/organizationStore';

const Portfolio = defineAsyncComponent(() => import('./Portfolio.vue'));
const Home = defineAsyncComponent(() => import('./Home.vue'));

const organizationStore = useOrganizationStore();
const baseHostname = (import.meta.env.VITE_BASE_URL || '')
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    .split(':')[0]
    .toLowerCase();
const currentHostname = window.location.hostname.toLowerCase();
const isCustomSubdomain = currentHostname.endsWith(`.${baseHostname}`)
    && currentHostname !== `www.${baseHostname}`;

const componentToRender = computed(() => {
    if (!isCustomSubdomain) {
        return Home;
    }

    if (organizationStore.organizationInfoLoading) {
        return null;
    }

    return organizationStore.organization.subdomain ? Portfolio : Home;
});
</script>
